import React from "react";

import Input from "../app2components/base/Input";
import styles from "./GradientProperties.module.css";
import { COLOR_PICKER } from "../constants/InputConstants.mjs";

const PALETTE_PREFIX = "colors-";

/** Expects a flattened set of color props */
const GradientProperties = ({ element, onChange, disabled, background = false, fallbackColor }) => {
  const { gc1, gc2, gr } = {
    gc1: background ? "bgGc1" : "gc1",
    gc2: background ? "bgGc2" : "gc2",
    gr: background ? "bgGr" : "gr",
  };

  const FALLBACK_COLOR = fallbackColor || `${PALETTE_PREFIX}0`;

  const getValue = (path, fallback) => element.get(path, fallback);
  const prepChange = (path, fallback) => [path, getValue(path, fallback)];

  // * just commenting for now
  // const swapValues = () => {
  //   // Here we want to be able to swap the first gradient value with the second gradient value
  //   const color1 = getValue(gc1, FALLBACK_COLOR);
  //   const color2 = getValue(gc2, FALLBACK_COLOR);

  //   // Call onChange for both colors to swap them
  //   onChange(gc1, color1)(color2); // Set first color to second color's value
  //   onChange(gc2, color2)(color1); // Set second color to first color's value
  // };

  // TODO: Improve Swap Colors UX interface. Could possibly be a button next to rotation to flip 180?
  return (
    <div className={styles.gradientProperties}>
      <Input
        data-testid="gradient-color-start-color-picker"
        color={getValue(gc1, FALLBACK_COLOR)}
        disabled={disabled}
        inputType={COLOR_PICKER}
        label="Color Start"
        onSIBeforeChange={onChange(...prepChange(gc1, FALLBACK_COLOR))}
        onSIChange={onChange(...prepChange(gc1, FALLBACK_COLOR))}
        onSIInput={onChange(...prepChange(gc1, FALLBACK_COLOR), false)}
      />
      {/* <Box className={styles.swapColors}>
        <Tooltip>
          <span slot="content">
            <Text>Swap Colors</Text>
          </span>
          <Button variant="icon" iconPrefix="swapValues" iconSize="20" onSIClick={swapValues} />
        </Tooltip>
      </Box> */}

      <Input
        data-testid="gradient-color-end-color-picker"
        color={getValue(gc2, FALLBACK_COLOR)}
        disabled={disabled}
        inputType={COLOR_PICKER}
        label="Color End"
        onSIBeforeChange={onChange(...prepChange(gc2, FALLBACK_COLOR))}
        onSIChange={onChange(...prepChange(gc2, FALLBACK_COLOR))}
        onSIInput={onChange(...prepChange(gc2, FALLBACK_COLOR), false)}
      />
      <Input
        data-testid="gradient-rotation-color-picker"
        label="Rotation"
        disabled={disabled}
        value={getValue(gr, 0)}
        type="number"
        min="0"
        max="360"
        cycle
        step="1"
        units="&deg;"
        onSIBeforeChange={onChange(...prepChange(gr, 0))}
        onSIInput={onChange(...prepChange(gr, 0), false)}
      />
    </div>
  );
};

export default GradientProperties;
